import {useFormContext} from 'react-hook-form';
import {NetworkDetailsFormValues, NetworkNodeFieldPath} from '../../../types';
import {SVG} from '../../../../../../../constants/assetLists';

type PermissionToggleCellProps = {
  selectedFieldPath: NetworkNodeFieldPath;
  roleIndex: number;
  permissionId: string;
  showGroupBorder: boolean;
  displayBorder?: boolean;
};

function PermissionToggleCell({
  selectedFieldPath,
  roleIndex,
  permissionId,
  showGroupBorder,
  displayBorder = true,
}: PermissionToggleCellProps) {
  const {watch, setValue} = useFormContext<NetworkDetailsFormValues>();
  const permissionsPath =
    `${selectedFieldPath}.roles.${roleIndex}.permissions` as const;
  const permissions = watch(permissionsPath) ?? [];
  const isGranted = permissions.includes(permissionId);

  const customPermission = watch(
    `${selectedFieldPath}.roles.${roleIndex}.customPermission`,
  );

  const toggle = () => {
    if (!customPermission) return;
    const next = isGranted
      ? permissions.filter(id => id !== permissionId)
      : [...permissions, permissionId];
    setValue(permissionsPath, next, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });
  };

  return (
    <td
      className={`h-10 ${displayBorder ? 'border-y border-y-gray70' : 'border-t border-t-gray70'} ${showGroupBorder ? 'border-s border-s-gray80' : ''}`}
      style={{width: '72px', maxWidth: '72px'}}>
      <div className="h-full flex justify-center items-center">
        <button
          type="button"
          className={`w-6 h-6 rounded-lg flex justify-center items-center 
            ${customPermission ? 'hover:bg-pastelBlue transition-all duration-300' : 'cursor-not-allowed'}`}
          disabled={!customPermission}
          onClick={toggle}>
          <img
            src={isGranted ? SVG?.tickGreenIcon : SVG.closeDarkIcon}
            alt="icon"
            className={`${isGranted ? 'w-[18px] h-[18px]' : 'w-[12px] h-[12px]'} object-contain`}
          />
        </button>
      </div>
    </td>
  );
}

export default PermissionToggleCell;
